import React from "react";
import axios from 'axios';
import '../BillPayComponent/billPayy.css';
import $, { timers } from "jquery";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';

import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";

import Select from 'react-select';
import { selectedRechargableAmnt2, setBillPayMobile, setBillPayOperator, setBillPayOptional, setBillPayTxnHistory, setCurrentBillerName, setSelectedBillerCategoryCode } from "../../redux/billpayDetails/billpay.action";
import { Link } from "react-router-dom";
import RecentTransaction from "./RecentTransaction";
import { resetAeps } from "../../redux/aeps/aeps.action";
import { resetRecharge } from "../../redux/recharge/recharge.action";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();
class BillPay extends React.Component {
	constructor(props) {
		super(props);
		this.state = {

			activeIcon: '',
			billerConfigList: [],
			billerInfoList: [],
			errorMessage: '',
			billFechErrMessage: '',
			mobileErrMsg: '',
			customParamValidationMap: '',
			optionalField: '',
			opFieldDisplay: '',
			optionalFieldVal: '',
			selectedBiller: '',
			mobile: '',
			billFetchResponse: '',
			fetchedBill: '',
			cateGory: '',
			optionalFieldKeys: [],
			fetchBillStatus: '',
			lockCustomField: '',
			showAmountField: '',
			showMobileField: '',

			emptyBillrList: [
				{ value: "No biller found", label: "No biller found" },

			]
		}
	}
	optionalFieldPrameterMap = new Map();
	optionalFieldPrameterMap1 = new Map();
	optionalFieldPrameterMap2 = new Map();
	customParamValidationMap = new Map();


	loadBillerByCategories = (event, value) => {
		event.preventDefault();
		this.optionalFieldPrameterMap = new Map();
		this.optionalFieldPrameterMap1 = new Map();
		this.optionalFieldPrameterMap2 = new Map();
		this.customParamValidationMap = new Map();

		this.setState({
			lockCustomField: '',
			mobile: '',
			showAmountField: '',
			showMobileField: '',
			billerConfigList: [],
			billerInfoList: [],
			errorMessage: '',
			optionalField: '',
			opFieldDisplay: '',
			billFechErrMessage: '',
			mobileErrMsg: '',
			customParamValidationMap: '',
			billFetchResponse: '',
			fetchedBill: '',
			optionalFieldVal: '',
			mapVal: ''
		})
		var loadBillerUrl = '/api/v1/catalog/billpay/biller/by-category/';
		if (value == 'elctr') {
			loadBillerUrl = loadBillerUrl + 'ELECTRICITY';
			this.setState({
				cateGory: 'ELECTRICITY'
			})
		}

		if (value == 'watr') {
			loadBillerUrl = loadBillerUrl + 'WATER';
			this.setState({
				cateGory: 'WATER'
			})
		}

		if (value == 'gas') {
			loadBillerUrl = loadBillerUrl + 'GAS';
			this.setState({
				cateGory: 'GAS'
			})
		}
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		var billerConfig = {
			id: '',
			operator: '',
			state: '',
			category: '',
			questions: [],
			endpoint: ''
		}

		var billerConfigList = [];
		var billerInfoList = [];

		var stateName = 'all';
		httpClient.post(loadBillerUrl, '',
			{ headers }
		).then((response) => {
			this.setState({
				activeIcon: value
			})
			if (response.data != null && response.data != undefined && 
				
				
				response.data != '') {
				if (response.data.length > 0) {

					this.setState({
						showMobileField: 'true',
						showAmountField: 'true'
					})


					store.dispatch(setSelectedBillerCategoryCode(response.data[0].category));

					response.data.map(biller => {
						stateName = process.env.REACT_APP_BILLPAYSTATE;
						// stateName='all';

						if (stateName == 'all') {
							billerConfigList.push(biller);
							var billerInfo = {
								value: '',
								label: ''
							}
							billerInfo.value = biller.id;
							billerInfo.label = biller.operator;
							billerInfoList.push(billerInfo);
						} else {
							if (biller.state == stateName) {
								billerConfigList.push(biller);
								var billerInfo = {
									value: '',
									label: ''
								}
								billerInfo.value = biller.id;
								billerInfo.label = biller.operator;
								billerInfoList.push(billerInfo);
							}
						}

					})
				}
				if (response.data.length = 0) {
					this.setState({
						billerConfigList: [],
						showMobileField: '',
						showAmountField: ''
					})
				}
			}
			console.log('billerlist details' + JSON.stringify(billerConfigList));
			console.log('billerInfoList details' + JSON.stringify(billerInfoList));

			this.setState({
				billerConfigList: billerConfigList,
				billerInfoList: billerInfoList
			})

		}).catch(error => {
			this.setState({
				errorMessage: 'Something went wrong in load biller details,please try again later!',
				showMobileField: '',
				showAmountField: ''
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}


		});
	}
	loadBillerByCategoriesOnLoad = (value) => {

		this.optionalFieldPrameterMap = new Map();
		this.optionalFieldPrameterMap1 = new Map();
		this.optionalFieldPrameterMap2 = new Map();
		this.customParamValidationMap = new Map();

		this.setState({
			lockCustomField: '',
			mobile: '',
			showMobileField: '',
			showAmountField: '',
			billerConfigList: [],
			billerInfoList: [],
			errorMessage: '',
			optionalField: '',
			opFieldDisplay: '',
			billFechErrMessage: '',
			mobileErrMsg: '',
			customParamValidationMap: '',
			billFetchResponse: '',
			fetchedBill: '',
			optionalFieldVal: '',
			mapVal: ''
		})
		var loadBillerUrl = '/api/v1/catalog/billpay/biller/by-category/';
		if (value == 'elctr') {
			loadBillerUrl = loadBillerUrl + 'ELECTRICITY';
			this.setState({
				cateGory: 'ELECTRICITY'
			})
		}

		if (value == 'watr') {
			loadBillerUrl = loadBillerUrl + 'WATER';
			this.setState({
				cateGory: 'WATER'
			})
		}

		if (value == 'gas') {
			loadBillerUrl = loadBillerUrl + 'GAS';
			this.setState({
				cateGory: 'GAS'
			})
		}
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		var billerConfig = {
			id: '',
			operator: '',
			state: '',
			category: '',
			questions: [],
			endpoint: ''
		}

		var billerConfigList = [];
		var billerInfoList = [];

		var stateName = 'all';
		httpClient.post(loadBillerUrl, '',
			{ headers }
		).then((response) => {
			this.setState({
				activeIcon: value
			})
			if (response.data != null && response.data != undefined && response.data != '') {
				if (response.data.length > 0) {

					this.setState({
						showMobileField: 'true',
						showAmountField: 'true',
					})

					store.dispatch(setSelectedBillerCategoryCode(response.data[0].category));

					response.data.map(biller => {

						// alert(JSON.stringify(biller));
						stateName = process.env.REACT_APP_BILLPAYSTATE;
						// stateName='all';

						if (stateName == 'all') {
							billerConfigList.push(biller);
							var billerInfo = {
								value: '',
								label: ''
							}
							billerInfo.value = biller.id;
							billerInfo.label = biller.operator;
							billerInfoList.push(billerInfo);
						} else {
							if (biller.state == stateName) {
								billerConfigList.push(biller);
								var billerInfo = {
									value: '',
									label: ''
								}
								billerInfo.value = biller.id;
								billerInfo.label = biller.operator;
								billerInfoList.push(billerInfo);
							}
						}

					})
				}
				if (response.data.length = 0) {
					this.setState({
						billerConfigList: [],
						showAmountField: '',
						showMobileField: ''
					})
				}
			}
			console.log('billerlist details' + JSON.stringify(billerConfigList));
			console.log('billerInfoList details' + JSON.stringify(billerInfoList));

			this.setState({
				billerConfigList: billerConfigList,
				billerInfoList: billerInfoList
			})

		}).catch(error => {
			this.setState({
				errorMessage: 'Something went wrong in load biller details,please try again later!',
				showAmountField: '',
				showMobileField: ''
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}


		});
	}

	selectBiller = (selected) => {
		
		store.dispatch(setCurrentBillerName(''));
		this.setState({
			lockCustomField: '',
			mobile: '',
			// showAmountField: '',
			// showMobileField: '',
			selectedBiller: selected,
			optionalField: '',
			opFieldDisplay: '',
			mobileErrMsg: '',
			customParamValidationMap: '',
			billFechErrMessage: '',
			billFetchResponse: '',
			fetchedBill: '',
			optionalFieldVal: '',
			mapVal: ''
		})
		store.dispatch(setCurrentBillerName(selected.label));
		this.optionalFieldPrameterMap = new Map();
		this.optionalFieldPrameterMap1 = new Map();
		this.optionalFieldPrameterMap2 = new Map();
		this.customParamValidationMap = new Map();

		if (this.state.billerConfigList.length > 0) {
			this.state.billerConfigList.map(billerConfig => {
				if (billerConfig.id == selected.value) {

					billerConfig.questions.map(conf => {

						this.optionalFieldPrameterMap.set(conf.optionalField, '');
						this.optionalFieldPrameterMap1.set(conf.optionalField, conf.opFieldDisplay);
						this.optionalFieldPrameterMap2.set(conf.optionalField, conf.regex);
					});

				}
			})
		}

		

		var optionalFieldKeys = [...this.optionalFieldPrameterMap.keys()];
		this.setState({
			optionalFieldKeys: optionalFieldKeys
		})
	}

	enterOpfieldVal = (e, opFieldVal) => {

		console.log('opFieldVal..' + opFieldVal)
		console.log('value..' + e.target.value)
		this.customParamValidationMap.set(opFieldVal, '');
		this.optionalFieldPrameterMap.set(opFieldVal, e.target.value);
		this.setState({
			mapVal: this.optionalFieldPrameterMap
		})
		// var itr = this.optionalFieldPrameterMap.keys();
	}

	errorMessageCall = (message) => {
		this.setState({
			displayErrorMsg: message
		})
	}

	enterMobileNumber = (event) => {
		this.setState({
			mobileErrMsg: '',
			mobile: event.target.value
		})
	}

	componentDidMount() {
		store.dispatch(setCurrentBillerName(''));
		this.loadTxnHistory();
		this.loadBillerByCategoriesOnLoad('elctr')
	}
	componentWillUnmount() {
	}

	enterAmount = (event) => {
		this.setState({
			enteredAmount: event.target.value
		})
	}



	validationWithRegex(value, regex) {
		console.log('validationWithRegex value=' + value + ';regex=' + regex);
		if (regex != null && regex != undefined && regex != '') {
			var re = new RegExp(regex);
			if (!re.test(value)) {

				return false;
			}
			else {

				return true;
			}
		} else {
			return true;
		}

	}

	billpayValidation = (e, action, data) => {
		e.preventDefault();

		var mobileValidation = false;
		var customParamValidation = false;
		this.setState({
			mobileErrMsg: '',
			customParamValidationMap: ''
		})


		if (this.state.mobile == '' || this.state.mobile.length < 10) {

			mobileValidation = false;
			this.setState({
				mobileErrMsg: 'Please enter correct Mobile No.'
			})
		} else {
			mobileValidation = true;
		}

		// var customParamValidationMap = new Map();


		if (this.optionalFieldPrameterMap.size > 0) {
			var optionalFieldKeys = [...this.optionalFieldPrameterMap.keys()];

			optionalFieldKeys.map(optionalField => {

				if (this.optionalFieldPrameterMap.get(optionalField) == ''
					|| this.validationWithRegex(this.optionalFieldPrameterMap.get(optionalField),
						this.optionalFieldPrameterMap2.get(optionalField)) == false
				) {
					console.log('value is empty')
					customParamValidation = false;
					this.customParamValidationMap.set(optionalField, 'Please enter correct value for above field');
					console.log('Please enter correct value for above field for' + optionalField)
				} else {
					console.log('value is..' + this.optionalFieldPrameterMap.get(optionalField))
					customParamValidation = true;
				}
			})
		}

		console.log('validation map size...' + this.customParamValidationMap.size)

		if (mobileValidation == true && customParamValidation == true) {

			this.customParamValidationMap = new Map();
			if (action == 'fetch') {
				this.fetchBill(data);
			}
			if (action == 'paybill') {
				this.proceedToBillPay(data);
			}

		}
	}

	fetchBill = (data) => {

		this.setState({
			fetchBillStatus: 'loading'
		})

		this.setState({
			billFechErrMessage: '',
			mobileErrMsg: '',
			customParamValidationMap: '',
			fetchBillClicked: true,
			billFetchResponse: '',
			fetchedBill: ''

		})
		var header = {
			msgType: "BILL_FETCH",
			service: "BILLPAY",
			src: 'billpay',
			dst: 'billpay',
			channel: "WHITELABEL",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			time: moment().utc(),
		}
		var transaction = {
			mobile: this.state.mobile,
			amount: '',
			operator: this.state.selectedBiller.value,
			customerId: this.optionalFieldPrameterMap.get(this.state.optionalField),
			category: this.state.cateGory
		}

		const obj = Object.fromEntries(this.optionalFieldPrameterMap);
		var orderRequest = {
			header: header,
			device: this.props.deviceInfo,
			transaction: transaction,
			validated: true,
			payment: "PARTNER_BALANCE",
			agentId: this.props.agentInfo.id,
			optional: obj
		}



		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		var fetchUrl = '/api/v1/billpay/order/fetch';

		console.log('fetch biller req:' + JSON.stringify(orderRequest));

		httpClient.post(fetchUrl, orderRequest, {
			timeout: 60 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {


			console.log('fetctch biller response' + JSON.stringify(response.data));
			if (response.data.response.success == true) {


				this.setState({
					fetchBillStatus: 'completed',
					lockCustomField: 'true'
				})
				var billFetchResponse = {
					header: response.data.header,
					response: response.data.response,
					bill: response.data.bill,
					optional: response.data.optional
				}
				this.setState({
					billFetchResponse: billFetchResponse,
					fetchedBill: billFetchResponse.bill
				})
			} else {
				this.setState({
					fetchBillStatus: 'completed',
					lockCustomField: 'false'
				})
				this.setState({
					billFechErrMessage: response.data.response.displayMsg
				})
			}
		}).catch(error => {
			this.setState({
				fetchBillStatus: 'completed',
				lockCustomField: ''
			})
			this.setState({
				billFechErrMessage: 'Something went wrong,please try again later!'
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}

		})
	}


	proceedToBillPay = (amount) => {


		store.dispatch(setBillPayOptional(Object.fromEntries(this.optionalFieldPrameterMap)));
		store.dispatch(selectedRechargableAmnt2(amount));
		store.dispatch(setBillPayOperator(this.state.selectedBiller.value));
		store.dispatch(setBillPayMobile(this.state.mobile));


		setTimeout(() => {
			var billPayMoneyTransfer = document.getElementById('billPayMoneyTransfer');
			billPayMoneyTransfer.click();
		}, 1000);


	}

	loadTxnHistory() {
		store.dispatch(setBillPayTxnHistory('loading'));
		var url = '';
		url = '/api/v1/billpay/order/history';

		var d = new Date();
		d.setDate(d.getDate() - 2);
		var startDate = d.toISOString().slice(0, 10);
		var d1 = new Date();
		d1.setDate(d1.getDate() + 1);
		var endDate = d1.toISOString().slice(0, 10);
		console.log('to date..' + endDate);
		console.log('start date' + startDate);


		var header = {
			msgType: "ORDER_HISTORY",
			service: 'BILLPAY',
			src: "billpay",
			dst: "billpay",
			channel: "API",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			traceId: uuidv4(),
		}
		var request = {
			header: header,
			device: this.props.deviceInfo,
			agentId: this.props.agentInfo.id,
			pageNo: 0,
			startDate: startDate,
			endDate: endDate

		}

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('txn history req:' + JSON.stringify(request));

		httpClient.post(url, request, {
			timeout: 60 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {

			console.log(' response' + JSON.stringify(response.data));
			
			if (response.data.response.msg == 'SUCCESS') {

				store.dispatch(setBillPayTxnHistory(response.data.orders));
			} else {
				store.dispatch(setBillPayTxnHistory('error'));
			}
		}).catch(error => {

			store.dispatch(setBillPayTxnHistory('error'));
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}
		})
	}

	render() {


		return (

			<div>
				<HeadeCommon />
				<Menu />


				<div class="main">
					<div class="container-fluid">
						<div class="row">
							<div class="col-12 col-lg-5 col-xl-4">
								<div class="card-b" id="leftdiv">
									<div class='head'>
										<h3>Bill Pay</h3>
									</div>
									<div>
										<div class="top-box">
											<Link to='/billpay-transfer'>
												<button id='billPayMoneyTransfer' hidden={true}></button>
											</Link>
										</div>

										<div class="blrtab">

											{process.env.REACT_APP_SHOW_BILLPAYELECTRICITY == 'yes' &&
												<button type="button" id="elctr" class={this.state.activeIcon == 'elctr' && 'active'}><i class="elctr" onClick={e => this.loadBillerByCategories(e, 'elctr')}></i> <span>Electricity</span></button>
											}
											{process.env.REACT_APP_SHOW_BILLPAYWATER == 'yes' &&
												<button type="button" id="watr" class={this.state.activeIcon == 'watr' && 'active'}><i class="watr" onClick={e => this.loadBillerByCategories(e, 'watr')}></i> <span>Water</span></button>
											}
											{process.env.REACT_APP_SHOW_BILLPAYGAS == 'yes' &&
												<button type="button" id="gas" class={this.state.activeIcon == 'gas' && 'active'}><i class="gas" onClick={e => this.loadBillerByCategories(e, 'gas')}></i> <span>Gas</span></button>
											}

										</div>
										{this.state.errorMessage != '' &&
											<div class='valid-error'>
												{this.state.errorMessage}
											</div>
										}



										{/* <div class="billpaybox" id="mobiform"> */}

										{this.state.billerConfigList.length > 0 &&
											<div class="payform">

												<Select options={this.state.billerInfoList} class="form-control"
													placeholder="Biller Names..."
													SelectContainer={true}
													onChange={this.selectBiller}
												// readOnly={this.state.fetchBillData != '' ? true : false}
												/>

											</div>
										}

										{this.state.billerConfigList.length == 0 &&
											<div class="payform">

												<Select options={this.state.emptyBillrList} class="form-control"
													placeholder="Biller Names..."
													SelectContainer={true}

												// readOnly={this.state.fetchBillData != '' ? true : false}
												/>

											</div>
										}


										{
											this.state.optionalFieldKeys.length > 0 &&
											this.optionalFieldPrameterMap.size > 0 &&
											this.state.optionalFieldKeys.map(optionalFieldVal => (
												<div class="payform">
													<div class="form-floating">

														<input type="text" class="form-control" id={this.optionalFieldPrameterMap1.get(optionalFieldVal)}
															placeholder={this.optionalFieldPrameterMap1.get(optionalFieldVal)} required
															onChange={e => this.enterOpfieldVal(e, optionalFieldVal)}
															value={this.optionalFieldPrameterMap.get(optionalFieldVal)}
															name={this.optionalFieldPrameterMap1.get(optionalFieldVal)}
															readOnly={this.state.lockCustomField == 'true' && true} />
														<label for={this.optionalFieldPrameterMap1.get(optionalFieldVal)}>{this.optionalFieldPrameterMap1.get(optionalFieldVal)}</label>
														{this.customParamValidationMap != '' &&
															this.customParamValidationMap.size > 0 &&
															<div class='valid-error'>
																{this.customParamValidationMap.get(optionalFieldVal)}</div>
														}
													</div>
												</div>))
										}

										{this.state.showMobileField == 'true' &&
											<div class="payform" id='mobile'>

												<div class="form-floating">
													<input type="number" id="mdn" class="form-control" maxlength="10"
														onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
														onChange={this.enterMobileNumber} required
														readOnly={this.state.lockCustomField == 'true' && true}
														value={this.state.mobile}
														placeholder="Enter mobile" name="mobile">
													</input>
													<label for='mdn'>Mobile No</label>
												</div>
												{this.state.mobileErrMsg != '' &&
													<div class='valid-error'>
														{this.state.mobileErrMsg}
													</div>
												}

											</div>
										}


										{this.state.showAmountField == 'true' &&
											<div class="payform" id="amtbox1">
												<div class="form-floating">
													<input type="text" class="form-control" id="amt" placeholder="Amount"
														value={(this.state.fetchedBill != '' && this.state.fetchedBill.amount != null
															&& this.state.fetchedBill.amount > 0) ? this.state.fetchedBill.amount : ''} readOnly />
													<label for="amt">Amount</label>
													{this.state.selectedBiller != '' &&
														<button type="button" id="fetch1" class="frmbtn"
															disabled={this.state.lockCustomField == 'true' ? true : false}
															onClick={e => this.billpayValidation(e, 'fetch', '')}>Fetch Bill</button>
													}
												</div>
											</div>
										}
										{this.state.billFechErrMessage != '' &&
											<div class='valid-error'>
												{this.state.billFechErrMessage}</div>}

										{this.state.fetchedBill != '' &&
											(this.state.fetchedBill.amount != null
												&& this.state.fetchedBill.amount > 0 ?
												<div class="fetchbill" id="fetchdtl1">
													<p><span>Name:</span>  {this.state.fetchedBill.name}</p>
													<p><span>Bill No.:</span>  {this.state.fetchedBill.billNumber}</p>
													<p><span>Bill Date:</span>   {this.state.fetchedBill.billDate}</p>
													<p><span>Due Amount:</span>  ₹ {parseFloat(this.state.fetchedBill.amount).toFixed(2)}</p>
													<p><span>Due Date:</span>  {this.state.fetchedBill.dueDate}</p>
													<p><span>Address:</span>  {this.state.fetchedBill.address != null ?
														this.state.fetchedBill.address : 'NA'}</p>
													<p class="text-center mt-3 mb-2"><img src="images/bbp-hlogo.png" alt="BBPS" width="70" /></p>

												</div> :
												<div class="fetchbill" id="fetchdtl1">
													<p><span></span>You don't have any due amount</p>
												</div>)
										}
										{
											this.state.fetchedBill != '' ?
												(this.state.fetchedBill.amount != null
													&& this.state.fetchedBill.amount > 0 ?
													<div class="payform text-center">
														<button type="button" class="btn btn-primary" onClick={e => this.billpayValidation(e, 'paybill', this.state.fetchedBill.amount)}>Proceed</button>
													</div> :
													this.state.showAmountField == 'true' &&
													<div class="payform text-center">
														<button type="button" class="btn btn-primary" disabled>Proceed</button>
													</div>) :
												<div class="payform text-center">
													{this.state.showAmountField == 'true' &&
														<button type="button" class="btn btn-primary" disabled>Proceed</button>
													}
													{this.state.fetchBillStatus == 'loading' &&
														<div class='valid-success'>
															Bill Fetch in progress...
														</div>
													}

												</div>
										}

									</div>
								</div>
							</div>
							<div class="col-12 col-lg-7 col-xl-8">
								<div class="card-b" id="rightdiv">
									<RecentTransaction />
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, moneyTransferResponseDetails, createOrderResponseDetails,
			agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
			transferTotalAmount, deviceInfo, customerLimit,
			customerId, bankLogoListTxt, billerData, paremeterData,
			callBackUrl } }
) => ({
	errorMessage, loginErrorMessage, phone, moneyTransferResponseDetails,
	createOrderResponseDetails, agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
	transferTotalAmount, deviceInfo, customerLimit,
	customerId, bankLogoListTxt, billerData, paremeterData,
	callBackUrl
});

export default connect(mapStateToProps, null)(BillPay);

